import axios from "axios";
import { UrlApi } from "../Keys";
import { toast } from "react-toastify";

const dataInicial = {
  planFormativo: [],
  loadingMiPlanFormativo: false,
  planFormativoCo: [],
  loadingMiPlanFormativoCo: false,
  catalogo: [],
  loadingCatalogo: false,
  misCursos: [],
  loadingMisCursos: false,
  misLogros: [],
  loadingMisLogros: false,
  misLogrosCo: [],
  loadingMisLogrosCo: false,
  infoPlan: [],
  loadingInfoPlan: false,
  getInfoPlan: null,
  infoEvento: [],
  loadingInfoEvento: false,
  getInfoEvento: null,
  bio: [],
  loadingInfoBio: false,
  getBio: null,
  formador: [],
  loadingFormador: false,
  getFormador: null,
  modificacion: ''
};

const LOADING_PLAN_FORMATIVO = "LOADING_PLAN_FORMATIVO";
const PLAN_FORMATIVO = "PLAN_FORMATIVO";
const PLAN_FORMATIVO_ERROR = "PLAN_FORMATIVO_ERROR";

const LOADING_PLAN_FORMATIVO_CO = "LOADING_PLAN_FORMATIVO_CO";
const PLAN_FORMATIVO_CO = "PLAN_FORMATIVO_CO";
const PLAN_FORMATIVO_CO_ERROR = "PLAN_FORMATIVO_CO_ERROR";

const LOADING_CATALOGO = "LOADING_CATALOGO";
const CATALOGO = "CATALOGO";
const CATALOGO_ERROR = "CATALOGO_ERROR";

const LOADING_MIS_CURSOS = "LOADING_MIS_CURSOS";
const MIS_CURSOS = "MIS_CURSOS";
const MIS_CURSOS_ERROR = "MIS_CURSOS_ERROR";

const LOADING_MIS_LOGROS = "LOADING_MIS_LOGROS";
const MIS_LOGROS = "MIS_LOGROS";
const MIS_LOGROS_ERROR = "MIS_LOGROS_ERROR";

const LOADING_MIS_LOGROS_CO = "LOADING_MIS_LOGROS_CO";
const MIS_LOGROS_CO = "MIS_LOGROS_CO";
const MIS_LOGROS_CO_ERROR = "MIS_LOGROS_CO_ERROR";

const LOADING_INFO_PLAN = 'LOADING_INFO_PLAN'
const INFO_PLAN = 'INFO_PLAN'
const INFO_PLAN_ERROR = 'INFO_PLAN_ERROR'

const LOADING_INFO_EVENTO = 'LOADING_INFO_EVENTO'
const INFO_EVENTO = 'INFO_EVENTO'
const INFO_EVENTO_ERROR = 'INFO_EVENTO_ERROR'

const LOADING_INFO_BIO = 'LOADING_INFO_BIO'
const INFO_BIO = 'INFO_BIO'
const INFO_BIO_ERROR = 'INFO_BIO_ERROR'

const LOADING_FORMADOR = 'LOADING_FORMADOR'
const FORMADOR = 'FORMADOR'
const FORMADOR_ERROR = 'FORMADOR_ERROR'

const MODIFICAR_EXITO = 'MODIFICAR_EXITO'
const MODIFICAR_ERROR = 'MODIFICAR_ERROR'

const LIMPIAR_INFORMACION = 'LIMPIAR_INFORMACION'

//Reducers
export default function universidadInternaReducer(state = dataInicial, action) {
  switch (action.type) {
    case LOADING_PLAN_FORMATIVO:
      return { ...state, loadingMiPlanFormativo: action.loadingMiPlanFormativo };
    case PLAN_FORMATIVO:
      return { ...state, planFormativo: action.payload, loadingMiPlanFormativo: action.loadingMiPlanFormativo };
    case PLAN_FORMATIVO_ERROR:
      return { ...state, loadingMiPlanFormativo: action.loadingMiPlanFormativo };
    case LOADING_PLAN_FORMATIVO_CO:
      return { ...state, loadingMiPlanFormativoCo: action.loadingMiPlanFormativoCo };
    case PLAN_FORMATIVO_CO:
      return { ...state, planFormativoCo: action.payload, loadingMiPlanFormativoCo: action.loadingMiPlanFormativoCo };
    case PLAN_FORMATIVO_CO_ERROR:
      return { ...state, loadingMiPlanFormativoCo: action.loadingMiPlanFormativoCo };
    case LOADING_CATALOGO:
      return { ...state, loadingCatalogo: action.loadingCatalogo };
    case CATALOGO:
      return { ...state, catalogo: action.payload, loadingCatalogo: action.loadingCatalogo };
    case CATALOGO_ERROR:
      return { ...state, loadingCatalogo: action.loadingCatalogo };
    case LOADING_MIS_CURSOS:
      return { ...state, loadingMisCursos: action.loadingMisCursos };
    case MIS_CURSOS:
      return { ...state, misCursos: action.payload, loadingMisCursos: action.loadingMisCursos };
    case MIS_CURSOS_ERROR:
      return { ...state, loadingMisCursos: action.loadingMisCursos };
    case LOADING_MIS_LOGROS:
      return { ...state, loadingMisLogros: action.loadingMisLogros };
    case MIS_LOGROS:
      return { ...state, misLogros: action.payload, loadingMisLogros: action.loadingMisLogros };
    case MIS_LOGROS_ERROR:
      return { ...state, loadingMisLogros: action.loadingMisLogros };

    case LOADING_MIS_LOGROS_CO:
      return { ...state, loadingMisLogrosCo: action.loadingMisLogrosCo };
    case MIS_LOGROS_CO:
      return { ...state, misLogrosCo: action.payload, loadingMisLogrosCo: action.loadingMisLogrosCo };
    case MIS_LOGROS_CO_ERROR:
      return { ...state, loadingMisLogrosCo: action.loadingMisLogrosCo };

    case LOADING_INFO_PLAN:
      return { ...state, loadingInfoPlan: action.loadingInfoPlan, getInfoPlan: false };
    case INFO_PLAN:
      return { ...state, infoPlan: action.payload, loadingInfoPlan: action.loadingInfoPlan, getInfoPlan: true };
    case INFO_PLAN_ERROR:
      return { ...state, loadingInfoPlan: action.loadingInfoPlan, getInfoPlan: true };
    case INFO_EVENTO:
      return { ...state, infoEvento: action.payload, loadingInfoEvento: action.loadingInfoEvento, getInfoEvento: true };
    case LOADING_INFO_EVENTO:
      return { ...state, loadingInfoEvento: action.loadingInfoEvento, getInfoEvento: false };
    case INFO_EVENTO_ERROR:
      return { ...state, loadingInfoEvento: action.loadingInfoEvento, getInfoEvento: true };
    case INFO_BIO:
      return { ...state, bio: action.payload, loadingInfoBio: action.loadingInfoBio, getBio: true };
    case LOADING_INFO_BIO:
      return { ...state, loadingInfoBio: action.loadingInfoBio, getBio: false };
    case INFO_BIO_ERROR:
      return { ...state, loadingInfoBio: action.loadingInfoBio, getBio: true };
    case FORMADOR:
      return { ...state, formador: action.payload, loadingFormador: action.loadingFormador, getFormador: true };
    case LOADING_FORMADOR:
      return { ...state, loadingFormador: action.loadingFormador, getFormador: false };
    case FORMADOR_ERROR:
      return { ...state, loadingFormador: action.loadingFormador, getFormador: true };

    case MODIFICAR_EXITO:
      return { ...state, modificacion: action.modificacion }
    case MODIFICAR_ERROR:
      return { ...state, modificacion: action.modificacion }

    case LIMPIAR_INFORMACION:
      return {
        ...state,
        infoPLan: [],
        loadingInfoPlan: false,
        getInfoPlan: null,
        infoEvento: [],
        loadingInfoEvento: false,
        getInfoEvento: null,
        bio: [],
        loadingInfoBio: false,
        getBio: null,
        formador: [],
        loadingFormador: false,
        getFormador: null,
        misLogrosCo: [],
        loadingMisLogrosCo: false,
        planFormativoCo: [],
        loadingMiPlanFormativoCo: false,
      }
    default:
      return { ...state };
  }
}

export const obtenerMiPlanFormativo = (token, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_PLAN_FORMATIVO,
    loadingMiPlanFormativo: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch = 
      "<entity name='new_participanteporeventodecapacitacion'>" +
      "<attribute name='new_participanteporeventodecapacitacionid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='new_alcance' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_eventodecapacitacion' />" +
      "<filter type='and'>" +
      "<condition attribute='new_tipodecurso' operator='eq' value='958770000' />" +
      "<condition attribute='statuscode' operator='eq' value='100000005' />" +
      "<condition attribute='new_alcance' operator='eq' value='958770001' />" +
      "</filter>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ac'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='like' value='" +
      usuarioPortalRh +
      "' />" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_eventodecapacitacion' from='new_eventodecapacitacionid' to='new_eventodecapacitacion' link-type='inner' alias='ad'>" +
      "<filter type='and'>" +
      "<condition attribute='new_habilitadoenportal' operator='eq' value='1' />" +
      "<condition attribute='statecode' operator='eq' value='0' />" +
      "</filter>" +
      "<link-entity name='new_programa' from='new_programaid' to='new_programa' link-type='outer' alias='ae'>" +
      "<attribute name='new_name' />" +
      "<link-entity name='new_eje' from='new_ejeid' to='new_eje' link-type='outer' alias='af'>" +
      "<attribute name='new_name' />" +
      "<order attribute='new_name' descending='false' />" +
      "</link-entity>" +
      "</link-entity>" +
      "<link-entity name='new_maestrodecurso' from='new_maestrodecursoid' to='new_cursomaestro' link-type='inner' alias='ag'>" +
      "<attribute name='new_maestrodecursoid' />" +
      "<attribute name='new_name' />" +
      "</link-entity>" +
      "</link-entity>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: PLAN_FORMATIVO,
      payload: response.data,
      loadingMiPlanFormativo: false,
    });
  } catch (error) {
    dispatch({
      type: PLAN_FORMATIVO_ERROR,
      loadingMiPlanFormativo: false,
    });
  }
};

export const obtenerMiPlanFormativoCo = (token, usuarioPortalRh, fechaHoy) => async (dispatch) => {
  dispatch({
    type: LOADING_PLAN_FORMATIVO_CO,
    loadingMiPlanFormativoCo: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch = `
    <entity name="new_participanteporeventodecapacitacion">
      <attribute name="new_participanteporeventodecapacitacionid" />
      <attribute name="new_name" />
      <attribute name="createdon" />
      <attribute name="new_eventodecapacitacion" />
      <filter type="and">
        <condition attribute="new_tipodecurso" operator="eq" value="958770000" />
        <condition attribute="statuscode" operator="eq" value="100000005" />
        <condition attribute="new_alcance" operator="eq" value="958770002" />
      </filter>
      <link-entity name="new_empleado" from="new_empleadoid" to="new_empleado" link-type="inner" alias="ac">
        <filter type="and">
          <condition attribute="new_correoelectronico" operator="like" value="${usuarioPortalRh}" />
        </filter>
      </link-entity>
      <link-entity name="new_eventodecapacitacion" from="new_eventodecapacitacionid" to="new_eventodecapacitacion" link-type="inner" alias="ad">
        <filter type="and">
          <condition attribute="new_habilitadoenportal" operator="eq" value="1" />
          <condition attribute="statecode" operator="eq" value="0" />
          <condition attribute="new_fechainicio" operator="on-or-after" value="${fechaHoy}" />
        </filter>
        <link-entity name="new_programa" from="new_programaid" to="new_programa" link-type="outer" alias="ae">
          <attribute name="new_name" /> 
          <link-entity name="new_eje" from="new_ejeid" to="new_eje" link-type="outer" alias="af">
            <attribute name="new_name" />
            <order attribute="new_name" descending="false" />
          </link-entity>
        </link-entity>
        <link-entity name="new_maestrodecurso" from="new_maestrodecursoid" to="new_cursomaestro" link-type="inner" alias="ag">
          <attribute name="new_maestrodecursoid" />
          <attribute name="new_name" />
      </link-entity>
      </link-entity>
    </entity>`;

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: PLAN_FORMATIVO_CO,
      payload: response.data,
      loadingMiPlanFormativoCo: false,
    });
  } catch (error) {
    dispatch({
      type: PLAN_FORMATIVO_CO_ERROR,
      loadingMiPlanFormativoCo: false,
    });
  }
};

export const infoPlan = (token, usuarioPortalRh, id) => async (dispatch) => {
  dispatch({
    type: LOADING_INFO_PLAN,
    loadingInfoPlan: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch =
      "<entity name='new_participanteporeventodecapacitacion'>" +
      "<attribute name='new_participanteporeventodecapacitacionid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_eventodecapacitacion' />" +
      "<order attribute='new_name' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='statuscode' operator='eq' value='100000005' />" +
      "</filter>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aa'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortalRh + "' />" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_eventodecapacitacion' from='new_eventodecapacitacionid' to='new_eventodecapacitacion' link-type='inner' alias='ab'>" +
      "<attribute name='new_eventodecapacitacionid' />" +
      "<attribute name='new_modalidaddecurso' />" +
      "<attribute name='new_fechafinalizacion' />" +
      "<attribute name='new_fechainicio' />" +
      "<attribute name='new_link' />" +
      "<attribute name='new_lugar' />" +
      "<filter type='and'>" +
      "<condition attribute='new_cursomaestro' operator='eq' value='" + id + "' />" +
      "<condition attribute='new_habilitadoenportal' operator='eq' value='1' />" +
      "<condition attribute='statecode' operator='eq' value='0' />" +
      "<condition attribute='statuscode' operator='eq' value='1' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: INFO_PLAN,
      payload: response.data,
      loadingInfoPlan: false,
    });
  } catch (error) {
    dispatch({
      type: INFO_PLAN_ERROR,
      loadingInfoPlan: false,
    });
  }
};

export const infoEvento = (token, usuarioPortalRh, id) => async (dispatch) => {
  dispatch({
    type: LOADING_INFO_EVENTO,
    loadingInfoEvento: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch = 
      "<entity name='new_participanteporeventodecapacitacion'>" +
      "<attribute name='new_participanteporeventodecapacitacionid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_eventodecapacitacion' />" +
      "<order attribute='new_name' descending='false' />" +
      "<filter type='or'>" +
      "<condition attribute='statuscode' operator='eq' value='100000005' />" +
      "<condition attribute='statuscode' operator='eq' value='100000000' />" +
      "<condition attribute='statuscode' operator='eq' value='100000001' />" +
      "</filter>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aa'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortalRh + "'/>" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_eventodecapacitacion' from='new_eventodecapacitacionid' to='new_eventodecapacitacion' link-type='inner' alias='ab'>" +
      "<attribute name='new_eventodecapacitacionid' />" +
      "<attribute name='new_modalidaddecurso' />" +
      "<attribute name='new_fechafinalizacion' />" +
      "<attribute name='new_fechainicio' />" +
      "<attribute name='new_link' />" +
      "<attribute name='new_lugar' />" +
      "<attribute name='new_duracionenhoras' />" +
      "<attribute name='new_espacio' />" +
      "<attribute name='new_sede' />" +
      "<filter type='and'>" +
      "<condition attribute='new_eventodecapacitacionid' operator='eq'  value='" + id + "' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: INFO_EVENTO,
      payload: response.data,
      loadingInfoEvento: false,
    });
  } catch (error) {
    dispatch({
      type: INFO_EVENTO_ERROR,
      loadingInfoEvento: false,
    });
  }
};

export const biografia = (token, id) => async (dispatch) => {
  dispatch({
    type: LOADING_INFO_BIO,
    loadingInfoBio: true,
  });

  try {
    var entidad = "new_eventodecapacitacions";
    var fetch =
      "<entity name='new_eventodecapacitacion'>" +
      "<attribute name='new_eventodecapacitacionid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='createdon' />" +
      "<order attribute='new_name' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='new_eventodecapacitacionid' operator='eq' value='" + id + "'/>" +
      "</filter>" +
      "<link-entity name='new_maestrodecurso' from='new_maestrodecursoid' to='new_cursomaestro' link-type='inner' alias='ac'>" +
      "<attribute name='new_bio' />" +
      "</link-entity>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: INFO_BIO,
      payload: response.data,
      loadingInfoBio: false,
    });
  } catch (error) {
    dispatch({
      type: INFO_BIO_ERROR,
      loadingInfoBio: false,
    });
  }
};

export const formador = (token, id) => async (dispatch) => {
  dispatch({
    type: LOADING_FORMADOR,
    loadingFormador: true,
  });

  try {
    var entidad = "new_instructorporeventodecapacitacins";
    var fetch =
      "<entity name='new_instructorporeventodecapacitacin'>" +
      "<attribute name='new_instructorporeventodecapacitacinid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_instructorexterno' />" +
      "<attribute name='new_instructorinterno' />" +
      "<order attribute='new_name' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='new_evento' operator='eq' value='" + id + "'/>" +
      "<condition attribute='statecode' operator='eq' value='0' />" +
      "</filter>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: FORMADOR,
      payload: response.data,
      loadingFormador: false,
    });
  } catch (error) {
    dispatch({
      type: FORMADOR_ERROR,
      loadingFormador: false,
    });
  }
};

export const miCatalogoCursos = (token, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_CATALOGO,
    loadingCatalogo: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch =
      "<entity name='new_participanteporeventodecapacitacion'>" +
      "<attribute name='new_participanteporeventodecapacitacionid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_eventodecapacitacion' />" +
      "<filter type='and'>" +
      "<condition attribute='new_tipodecurso' operator='eq' value='958770001' />" +
      "<condition attribute='statuscode' operator='eq' value='100000005' />" +
      "<condition attribute='new_alcance' operator='eq' value='958770001' />" +
      "</filter>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ac'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortalRh + "' />" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_eventodecapacitacion' from='new_eventodecapacitacionid' to='new_eventodecapacitacion' link-type='inner' alias='ad'>" +
      "<filter type='and'>" +
      "<condition attribute='new_habilitadoenportal' operator='eq' value='1' />" +
      "<condition attribute='statecode' operator='eq' value='0' />" +
      "</filter>" +
      "<link-entity name='new_programa' from='new_programaid' to='new_programa' link-type='outer' alias='ae'>" +
      "<attribute name='new_name' />" +
      "<link-entity name='new_eje' from='new_ejeid' to='new_eje' link-type='outer' alias='af'>" +
      "<attribute name='new_name' />" +
      "<order attribute='new_name' descending='false' />" +
      "</link-entity>" +
      "</link-entity>" +
      "<link-entity name='new_maestrodecurso' from='new_maestrodecursoid' to='new_cursomaestro' link-type='inner' alias='ag'>" +
      "<attribute name='new_maestrodecursoid' />" +
      "<attribute name='new_name' />" +
      "</link-entity>" +
      "</link-entity>" +
      "</entity>";
    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: CATALOGO,
      payload: response.data,
      loadingCatalogo: false,
    });
  } catch (error) {
    dispatch({
      type: CATALOGO_ERROR,
      loadingCatalogo: false,
    });
  }
};
//CODOCENTE
export const miCatalogoCursos2 = (token, usuarioPortalRh, fechaHoy) => async (dispatch) => {
  dispatch({
    type: LOADING_CATALOGO,
    loadingCatalogo: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch = `
    <entity name="new_participanteporeventodecapacitacion">
      <attribute name="new_participanteporeventodecapacitacionid" />
      <attribute name="new_name" />
      <attribute name="createdon" />
      <attribute name="new_eventodecapacitacion" />
      <filter type="and">
        <condition attribute="new_tipodecurso" operator="eq" value="958770001" />
        <condition attribute="statuscode" operator="eq" value="100000005" />
        <condition attribute="new_alcance" operator="eq" value="958770002" />
      </filter>
      <link-entity name="new_empleado" from="new_empleadoid" to="new_empleado" link-type="inner" alias="ac">
        <filter type="and">
          <condition attribute="new_correoelectronico" operator="like" value="${usuarioPortalRh}" />
        </filter>
      </link-entity>
      <link-entity name="new_eventodecapacitacion" from="new_eventodecapacitacionid" to="new_eventodecapacitacion" link-type="inner" alias="ad">
        <filter type="and">
          <condition attribute="new_habilitadoenportal" operator="eq" value="1" />
          <condition attribute="statecode" operator="eq" value="0" />
          <condition attribute="new_fechainicio" operator="on-or-after" value="${fechaHoy}" />
        </filter>
        <link-entity name="new_programa" from="new_programaid" to="new_programa" link-type="outer" alias="ae">
          <attribute name="new_name" /> 
          <link-entity name="new_eje" from="new_ejeid" to="new_eje" link-type="outer" alias="af">
            <attribute name="new_name" />
            <order attribute="new_name" descending="false" />
          </link-entity>
        </link-entity>
        <link-entity name="new_maestrodecurso" from="new_maestrodecursoid" to="new_cursomaestro" link-type="inner" alias="ag">
          <attribute name="new_maestrodecursoid" />
          <attribute name="new_name" />
      </link-entity>
      </link-entity>
    </entity>`;
    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: CATALOGO,
      payload: response.data,
      loadingCatalogo: false,
    });
  } catch (error) {
    dispatch({
      type: CATALOGO_ERROR,
      loadingCatalogo: false,
    });
  }
}

export const misCursosFetch = (token, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_MIS_CURSOS,
    loadingMisCursos: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch =
      "<entity name='new_participanteporeventodecapacitacion'>" +
      "<attribute name='new_participanteporeventodecapacitacionid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_eventodecapacitacion' />" +
      "<order attribute='statuscode' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='statuscode' operator='in'>" +
      "<value>1</value>" +
      "<value>100000000</value>" +
      "<value>100000001</value>" +
      "<value>100000004</value>" +
      "<value>100000006</value>" +
      "<value>100000008</value>" +
      "</condition>" +
      "<condition attribute='new_alcance' operator='eq' value='958770002' />" +
      "</filter>" +
      "<link-entity name='new_eventodecapacitacion' from='new_eventodecapacitacionid' to='new_eventodecapacitacion' link-type='inner' alias='aa'>" +
        "<filter type='and'>" +
          "<condition attribute='statecode' operator='eq' value='0' />" +
        "</filter>" +
      "<attribute name='new_eventodecapacitacionid' />" +
      "<link-entity name='new_maestrodecurso' from='new_maestrodecursoid' to='new_cursomaestro' link-type='inner' alias='ab'>" +
      "</link-entity>" +
      "</link-entity>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ao'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" +
      usuarioPortalRh +
      "' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: MIS_CURSOS,
      payload: response.data,
      loadingMisCursos: false,
    });
  } catch (error) {
    dispatch({
      type: MIS_CURSOS_ERROR,
      loadingMisCursos: false,
    });
  }
};

export const misLogrosFetch = (token, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_MIS_LOGROS,
    loadingMisLogros: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch =
      "<entity name='new_participanteporeventodecapacitacion'>" +
      "<attribute name='new_participanteporeventodecapacitacionid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_eventodecapacitacion' />" +
      "<order attribute='new_name' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='statuscode' operator='in'>" +
      "<value>100000003</value>" +
      "</condition>" +
      "<condition attribute='new_alcance' operator='eq' value='958770001' />" +
      "</filter>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ao'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortalRh + "' />" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_eventodecapacitacion' from='new_eventodecapacitacionid' to='new_eventodecapacitacion' link-type='outer' alias='ab'>" +
      "<attribute name='new_modalidaddecurso' />" +
      "<attribute name='new_fechafinalizacion' />" +
      "<attribute name='new_fechainicio' />" +
      "<attribute name='new_programa' />" +
      "<attribute name='new_institucion' />" +
      "<attribute name='new_cursomaestro' />" +
      "</link-entity>" +
      "<link-entity name='annotation' from='objectid' to='new_participanteporeventodecapacitacionid' link-type='outer' alias='ac'>" +
      "<attribute name='annotationid' />" +
      "</link-entity>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: MIS_LOGROS,
      payload: response.data,
      loadingMisLogros: false,
    });
  } catch (error) {
    dispatch({
      type: MIS_LOGROS_ERROR,
      loadingMisLogros: false,
    });
  }
};

export const misLogrosFetch2 = (token, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_MIS_LOGROS_CO,
    loadingMisLogrosCo: true,
  });

  try {
    var entidad = "new_participanteporeventodecapacitacions";
    var fetch = `
    <entity name="new_participanteporeventodecapacitacion">
      <attribute name="new_participanteporeventodecapacitacionid" />
      <attribute name="new_name" />
      <attribute name="createdon" />
      <attribute name="new_eventodecapacitacion" />
      <order attribute="new_name" descending="false" />
      <filter type="and">
        <condition attribute="statuscode" operator="in">
          <value>100000003</value>
        </condition>
        <condition attribute="new_alcance" operator="eq" value="958770002" />
      </filter>
      <link-entity name="new_empleado" from="new_empleadoid" to="new_empleado" link-type="inner" alias="ao">
      <filter type="and">
        <condition attribute="new_correoelectronico" operator="eq" value="${usuarioPortalRh}" />
      </filter>
    </link-entity>
    <link-entity name="new_eventodecapacitacion" from="new_eventodecapacitacionid" to="new_eventodecapacitacion" link-type="outer" alias="ab">
      <attribute name="new_modalidaddecurso" />  
      <attribute name="new_fechafinalizacion" />  
      <attribute name="new_fechainicio" />  
      <attribute name="new_programa" />  
      <attribute name="new_eventodecapacitacionid" />
      <attribute name="new_ideventodeformacin"/>
      <attribute name="new_institucion" />  
      <attribute name="new_cursomaestro" />  
    </link-entity>
    <link-entity name="annotation" from="objectid" to="new_participanteporeventodecapacitacionid" link-type="outer" alias="ac">
    <attribute name="subject" />
    <attribute name="notetext" />
    <attribute name="filename" />
    <attribute name="mimetype" />
    <attribute name="documentbody" />
    <attribute name="annotationid" />
      <order attribute="createdon" descending="true" />
    </link-entity>
    </entity>`;

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: MIS_LOGROS_CO,
      payload: response.data,
      loadingMisLogrosCo: false,
    });
  } catch (error) {
    dispatch({
      type: MIS_LOGROS_CO_ERROR,
      loadingMisLogrosCo: false,
    });
  }
};

export const aplicarEventoCodocente = (token, id) => async (dispatch) => {
  return toast.promise(
    new Promise((resolve, reject) => {
      debugger
      axios.put(
        `${UrlApi}api/hrfactors/participanteporevento`,
        {
          "new_participanteporeventodecapacitacionid": id,
          "statuscode": 0,
          "new_aplica": 100000000
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          dispatch({
            type: MODIFICAR_EXITO,
            payload: response.data,
            modificacion: "EXITO",
          });
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: MODIFICAR_ERROR,
            modificacion: "ERROR",
          });
          reject(error);
        });
    }),
    {
      pending: "Procesando...",
      success: "Te inscribiste con éxito!",
      error: {
        render({ data }) {
          return `${data}`;
        },
      },
    },
    {
      theme: "dark",
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  )
}

export const limpiarInformacion = () => async (dispatch) => {
  dispatch({
    type: LIMPIAR_INFORMACION,
  })
}